import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

export default function GettingStarted(setCurrentSection) {
  return (
    <section>
      <h1 className="text-2xl font-bold mb-4">
        Getting Started via Python Wrapper{" "}
        <span className="font-light text-base text-indigo-600">
          (recommended)
        </span>
      </h1>
      <ol className="list-decimal list-inside mb-4 text-gray-700 space-y-4 pl-4">
        <li>
          <strong>Install the app</strong> from the{" "}
          <a
            href="https://apps.apple.com/us/app/whenfin/id6504001973"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 hover:underline inline-flex items-center gap-1"
          >
            Apple App Store{" "}
            <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
          </a>
          . Register with a username and password (one account per developer is
          recommended, as notifications are sent to the most recently
          authenticated device).
        </li>
        <li>
          <strong>Create your first project</strong> in the app. Projects act as
          inboxes for notifications. You can create separate projects for
          different workflows (e.g., ML training vs. infrastructure).
        </li>
        <li>
          <strong>Save your project secret</strong> from the project inbox
          header. You’ll need this to configure your Python client.
        </li>
        <li>
          <strong>Install the Python client</strong> (Python 3.6+):
          <pre className="bg-slate-100 rounded px-2 py-1 mt-2 mb-2 text-sm text-gray-800 overflow-x-auto">
            pip3 install whenfin
          </pre>
        </li>
        <li>
          <strong>Initialize the client</strong> in your script:
          <pre className="bg-slate-100 rounded px-2 py-1 mt-2 mb-2 text-sm text-gray-800 overflow-x-auto">
            Whenfin.connect(USERNAME, PROJECT, SECRET)
          </pre>
        </li>
        <li>
          <strong>Send notifications</strong> from anywhere in your code:
          <pre className="bg-slate-100 rounded px-2 py-1 mt-2 mb-2 text-sm text-gray-800 overflow-x-auto">
            Whenfin.send(TITLE, MESSAGE)
          </pre>
        </li>
      </ol>

      <h1 className="text-2xl font-bold my-4 pt-6">Getting Started via API</h1>
      <p className="mb-3 pl-2">
        Whenfin also exposes all endpoints used by our app. You can perform all
        steps above via the API, but we recommend downloading the app to
        register your device notification token (otherwise, it can be hard to
        find).
      </p>
      <ol className="list-decimal list-inside mb-4 text-gray-700 space-y-4 pl-4">
        <li>
          <strong>Install the app</strong> from the{" "}
          <a
            href="https://apps.apple.com/us/app/whenfin/id6504001973"
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 hover:underline inline-flex items-center gap-1"
          >
            Apple App Store{" "}
            <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
          </a>
          . Register and log in.
        </li>
        <li>
          <strong>Explore the API endpoints</strong>:{" "}
          <a
            onClick={() => {
              setCurrentSection("API Reference");
            }}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 hover:underline inline-flex items-center gap-1"
          >
            View API Reference{" "}
            <ArrowTopRightOnSquareIcon className="w-4 h-4 inline" />
          </a>
        </li>
      </ol>
    </section>
  );
}
